<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    label: string
    value: string
    committedValue?: string
    color?: string
    paid?: { value: string; width: number; color: string; gradientTo?: string; label?: string }
    pending?: { value: string; width: number; color: string; label?: string; style?: 'solid' | 'striped' }
    total?: { value: string; label: string }
  }>(),
  { color: '#246586' },
)

const hasProgress = computed(() => !!props.paid || !!props.pending)
</script>

<template>
  <div data-component="VMetricCard">
    <div class="mt-3">
      <div class="relative mb-1.5 h-2 rounded-full bg-gray-200">
        <div
          v-if="pending"
          class="absolute inset-0 rounded-full"
          :style="{
            width: `min(max(${pending.width}%, 2px), 100%)`,
            backgroundColor: pending.color,
            ...(pending.style !== 'solid'
              ? {
                  backgroundImage:
                    'repeating-linear-gradient(-45deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)',
                }
              : {}),
          }"
        ></div>
        <div
          v-if="paid"
          class="absolute inset-0 rounded-full"
          :style="{
            width: `min(max(${paid.width}%, 2px), 100%)`,
            background: paid.gradientTo ? `linear-gradient(to right, ${paid.color}, ${paid.gradientTo})` : paid.color,
          }"
        ></div>
      </div>
      <div class="mt-0.5 flex items-center justify-between">
        <div class="flex items-center gap-5">
          <div v-if="paid" class="flex items-center gap-1.5">
            <div class="h-3 w-3 rounded" :style="{ backgroundColor: paid.color }"></div>
            <span class="text-xs font-semibold text-gray-700">{{ paid.value }}</span>
            <span class="text-xs text-gray-500">{{ paid.label ?? 'Paid' }}</span>
          </div>
          <div v-if="pending" class="flex items-center gap-1.5">
            <div
              class="h-3 w-3 rounded"
              :style="{
                backgroundColor: pending.color,
                ...(pending.style !== 'solid'
                  ? {
                      backgroundImage:
                        'repeating-linear-gradient(-45deg, transparent, transparent 2px, rgba(255,255,255,0.1) 2px, rgba(255,255,255,0.1) 4px)',
                    }
                  : {}),
              }"
            ></div>
            <span class="text-xs font-semibold text-gray-700">{{ pending.value }}</span>
            <span class="text-xs text-gray-500">{{ pending.label ?? 'Pending' }}</span>
          </div>
        </div>
        <div v-if="total" class="flex items-center gap-1.5">
          <span class="text-xs font-semibold text-gray-700">{{ total.value }}</span>
          <span class="text-xs text-gray-500">{{ total.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
